import { render, staticRenderFns } from "./InfoContact.vue?vue&type=template&id=16333324&scoped=true&"
import script from "./InfoContact.vue?vue&type=script&lang=js&"
export * from "./InfoContact.vue?vue&type=script&lang=js&"
import style0 from "./InfoContact.vue?vue&type=style&index=0&id=16333324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16333324",
  null
  
)

export default component.exports